import React from 'react';
import SingleDatePicker from '../SingleDatePicker';

const DateField = ({ data, onChangeField }) => {
  const {
    value,
    fld,
    error,
    errorMessage,
    disabled,
    caption,
    add,
    auto_current_date,
    ...rest
  } = data ?? {};
  return (
    <SingleDatePicker
      value={value}
      // value={data.value}
      onChange={onChangeField}
      name={fld}
      // name={data.fld}
      error={error ?? false}
      // error={data?.error ?? false}
      helperText={errorMessage || ''}
      // helperText={data?.errorMessage || ''}
      fullWidth
      disabled={disabled || false}
      // disabled={data?.disabled || false}
      label={caption || ''}
      // label={data?.caption || ''}
      add={add}
      auto_current_date={auto_current_date ?? false}
      // add={data?.add}
      //TODO: look into rest bug showing default js datepicker
      // {...rest}
      {...(data?.rest || {})}
    />
  );
};

export default DateField;
